import React from "react";

import InputLabel from "../Inputs/Layout/InputLabel";
import InputContainer from "../Inputs/Layout/InputContainer";
import StyledText from "ae-base/Base/StyledText";

import { useResources } from "@aetonix/hooks";

export default function OutputCustomOptions(props) {
	const { localizeFrom } = useResources();
	const schema = props.schema;
	const data = props.data;
	const style = props.style;

	const valueLocalization = schema.valueLocalization || schema.value_localization;
	const text = valueLocalization ? localizeFrom(valueLocalization, ".", data) : concatData(data);

	return (
		<InputContainer style={props.style}>
			<InputLabel schema={schema} title={props.title} contrast={props.contrast} ignoreObjectStyle />
			<StyledText selectable={true} light style={style} contrast={props.contrast} black={!props.contrast}>{text}</StyledText>
		</InputContainer>
	);
}

function concatData(data){
	return Object.keys(data).reduce((result, key) => {
		if(key === "_id") return result;
		return result.concat(data[key]);
	}, []).join(" ");
}